import React from "react";

import CsvImportModal from "Components/Common/CsvImport/CsvImportModal";
import { importPayment, importPaymentUpdate } from "common/services/payments.service";
import { PAYMENT_IMPORT_FIELDS, mapPaymentImportRow } from "./paymentImportConfig";

const PaymentsImportModal: React.FC<{
  isOpen: boolean;
  toggle: () => void;
  mode: "create" | "update";
  onImported?: () => void;
}> = ({ isOpen, toggle, mode, onImported }) => {
  const updating = mode === "update";
  return (
    <CsvImportModal
      isOpen={isOpen}
      toggle={toggle}
      title={updating ? "Update Payments from CSV" : "Import Payments"}
      subtitle={updating ? "Upload payment records to merge overlapping payment periods" : "Upload a CSV file to bulk-import payment records"}
      icon={updating ? "ri-refresh-line" : "ri-money-dollar-circle-line"}
      fields={PAYMENT_IMPORT_FIELDS}
      mapRow={mapPaymentImportRow}
      importRecords={updating ? importPaymentUpdate : importPayment}
      templatePath={`${process.env.PUBLIC_URL}/templates/${updating ? "payments_update_import_template.csv" : "payments_import_template.csv"}`}
      templateFileName={updating ? "payments_update_import_template.csv" : "payments_import_template.csv"}
      failedFileName={updating ? "Failed_Payments_Import_Update.csv" : "Failed_Payments_Import.csv"}
      recordLabel="payment"
      maxRecords={10000}
      batchSize={250}
      onImported={onImported}
    />
  );
};

export default PaymentsImportModal;
